import type { ToolUnavailabilityReason } from '@brightlocal/api-client';
import { TOOL_UNAVAILABILITY_REASON } from '@brightlocal/shared';

import { UNAVAILABLE_SCREEN } from '../consts';

// Most blocking reason first. A plan gap wins over the country: the customer is told what their
// plan lacks before where the tool works.
const SCREEN_BY_REASON = [
  [TOOL_UNAVAILABILITY_REASON.NO_ACTIVE_SUBSCRIPTION, UNAVAILABLE_SCREEN.NO_ACTIVE_PLAN],
  [TOOL_UNAVAILABILITY_REASON.CAPABILITY_DISABLED, UNAVAILABLE_SCREEN.NOT_IN_PLAN],
  [TOOL_UNAVAILABILITY_REASON.COUNTRY_NOT_SUPPORTED, UNAVAILABLE_SCREEN.UNSUPPORTED_COUNTRY]
] as const;

/**
 * Picks the screen for an unavailable tool from its reasons. Any other reason, or none, gets the
 * general screen with a way to contact support.
 */
export const resolveUnavailableScreen = (reasons: readonly ToolUnavailabilityReason[]) =>
  SCREEN_BY_REASON.find(([reason]) => reasons.includes(reason))?.[1] ?? UNAVAILABLE_SCREEN.GENERAL;
